import styled from 'styled-components'

import Box from '@ilg-totallymoney/ui/components/Box'
import { focusStyles } from '@ilg-totallymoney/ui/styles/focus'
import theme from '@ilg-totallymoney/ui/theme'

export const StyledButton = styled.button`
    background-color: transparent;
    border-width: 0;
    padding: 0;
    width: 100%;

    ${focusStyles}

    &:active, &:focus {
        ${theme.mediaMediumPlus`
            border-radius: ${theme.radii.borderRadius10};
        `}
    }

    &:hover {
        cursor: pointer;
    }
`

export const StyledImageContainer = styled(Box)`
    position: absolute;
    display: none;

    ${theme.mediaMediumPlus`
        display: flex;
        right: -16px !important;
    `}

    @media only screen and (min-width: ${theme.small + 10}px) {
        right: 0px !important;
    }
`
